import React, { useState } from 'react';
import Layout from './Layout';

export default function Synchronizing() {
  // WhatsApp state
  const [whatsappConnected, setWhatsappConnected] = useState(true);
  const [whatsappNumber, setWhatsappNumber] = useState('+1 (555) 123-4567');
  const [whatsappStats, setWhatsappStats] = useState({
    sentToday: 24,
    receivedToday: 18,
    connectedSince: '2023-10-15'
  });

  // Email state
  const [emailConnected, setEmailConnected] = useState(true);
  const [emailAddress, setEmailAddress] = useState('john@companycrm.com');
  const [emailStats, setEmailStats] = useState({
    sentToday: 42,
    receivedToday: 67,
    connectedSince: '2023-09-22'
  });

  // Modal states
  const [showWhatsappModal, setShowWhatsappModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [activeTab, setActiveTab] = useState('whatsapp'); // For integration tabs

  // Sample messages for preview
  const [messages, setMessages] = useState([
    { id: 1, type: 'whatsapp', contact: 'Sarah Johnson', preview: 'Looking forward to our meeting...', time: '10:30 AM', unread: true },
    { id: 2, type: 'email', contact: 'Mike Thompson', preview: 'Quarterly report is ready for review', time: '9:45 AM', unread: false },
    { id: 3, type: 'whatsapp', contact: 'David Wilson', preview: 'Thanks for the quick response!', time: 'Yesterday', unread: false },
    { id: 4, type: 'email', contact: 'Client Services', preview: 'Your ticket has been resolved', time: 'Yesterday', unread: true },
  ]);

  return (
    <Layout>
      <div className="min-h-screen bg-gray-50 p-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex justify-between items-center mb-8">
            <div>
              <h1 className="text-3xl font-bold text-gray-800">Communications Hub</h1>
              <p className="text-gray-600">Manage your WhatsApp and Email integrations</p>
            </div>
            <div className="flex space-x-2 bg-gray-100 p-1 rounded-lg">
              <button 
                onClick={() => setActiveTab('whatsapp')}
                className={`px-4 py-2 rounded-md text-sm font-medium ${activeTab === 'whatsapp' ? 'bg-white shadow-sm' : 'text-gray-600 hover:text-gray-800'}`}
              >
                WhatsApp
              </button>
              <button 
                onClick={() => setActiveTab('email')}
                className={`px-4 py-2 rounded-md text-sm font-medium ${activeTab === 'email' ? 'bg-white shadow-sm' : 'text-gray-600 hover:text-gray-800'}`}
              >
                Email
              </button>
              <button 
                onClick={() => setActiveTab('messages')}
                className={`px-4 py-2 rounded-md text-sm font-medium ${activeTab === 'messages' ? 'bg-white shadow-sm' : 'text-gray-600 hover:text-gray-800'}`}
              >
                Messages
              </button>
            </div>
          </div>

          {/* Stats Overview */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="bg-white rounded-xl shadow-sm p-5">
              <div className="flex items-center">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                  </svg>
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-gray-800">WhatsApp</h2>
                  <p className="text-gray-600">{whatsappConnected ? 'Connected' : 'Disconnected'}</p>
                </div>
              </div>
              <div className="mt-4 grid grid-cols-2 gap-2">
                <div className="bg-green-50 p-3 rounded-lg">
                  <p className="text-xs text-green-600">Sent Today</p>
                  <p className="text-lg font-bold text-gray-800">{whatsappStats.sentToday}</p>
                </div>
                <div className="bg-blue-50 p-3 rounded-lg">
                  <p className="text-xs text-blue-600">Received Today</p>
                  <p className="text-lg font-bold text-gray-800">{whatsappStats.receivedToday}</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm p-5">
              <div className="flex items-center">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <div>
                  <h2 className="text-lg font-semibold text-gray-800">Email</h2>
                  <p className="text-gray-600">{emailConnected ? 'Connected' : 'Disconnected'}</p>
                </div>
              </div>
              <div className="mt-4 grid grid-cols-2 gap-2">
                <div className="bg-green-50 p-3 rounded-lg">
                  <p className="text-xs text-green-600">Sent Today</p>
                  <p className="text-lg font-bold text-gray-800">{emailStats.sentToday}</p>
                </div>
                <div className="bg-blue-50 p-3 rounded-lg">
                  <p className="text-xs text-blue-600">Received Today</p>
                  <p className="text-lg font-bold text-gray-800">{emailStats.receivedToday}</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-sm p-5">
              <h2 className="text-lg font-semibold text-gray-800 mb-4">Quick Actions</h2>
              <div className="space-y-3">
                <button className="w-full flex items-center justify-between p-3 bg-gray-50 hover:bg-gray-100 rounded-lg">
                  <span className="text-gray-700">New Broadcast</span>
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                  </svg>
                </button>
                <button className="w-full flex items-center justify-between p-3 bg-gray-50 hover:bg-gray-100 rounded-lg">
                  <span className="text-gray-700">Email Campaign</span>
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                  </svg>
                </button>
                <button className="w-full flex items-center justify-between p-3 bg-gray-50 hover:bg-gray-100 rounded-lg">
                  <span className="text-gray-700">Integration Settings</span>
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          {/* Main Content Area */}
          <div className="bg-white rounded-xl shadow-sm overflow-hidden">
            <div className="border-b border-gray-200">
              <nav className="flex -mb-px">
                <button
                  className={`py-4 px-6 text-sm font-medium border-b-2 ${activeTab === 'whatsapp' ? 'border-green-500 text-green-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`}
                  onClick={() => setActiveTab('whatsapp')}
                >
                  WhatsApp Configuration
                </button>
                <button
                  className={`py-4 px-6 text-sm font-medium border-b-2 ${activeTab === 'email' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`}
                  onClick={() => setActiveTab('email')}
                >
                  Email Configuration
                </button>
                <button
                  className={`py-4 px-6 text-sm font-medium border-b-2 ${activeTab === 'messages' ? 'border-purple-500 text-purple-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`}
                  onClick={() => setActiveTab('messages')}
                >
                  Recent Messages
                </button>
              </nav>
            </div>

            <div className="p-6">
              {activeTab === 'whatsapp' && (
                <div>
                  <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-bold text-gray-800">WhatsApp Business Setup</h2>
                    <div className="flex items-center">
                      <span className={`px-3 py-1 rounded-full text-sm font-medium mr-3 ${whatsappConnected ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                        {whatsappConnected ? 'Connected' : 'Disconnected'}
                      </span>
                      <button 
                        onClick={() => whatsappConnected ? setWhatsappConnected(false) : setShowWhatsappModal(true)}
                        className={`px-4 py-2 rounded-lg font-medium ${whatsappConnected ? 'bg-red-500 hover:bg-red-600' : 'bg-green-500 hover:bg-green-600'} text-white`}
                      >
                        {whatsappConnected ? 'Disconnect' : 'Connect'}
                      </button>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <h3 className="text-lg font-medium text-gray-800 mb-3">Connection Details</h3>
                      <div className="space-y-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
                          <p className="text-gray-900">{whatsappNumber}</p>
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">Connected Since</label>
                          <p className="text-gray-900">{whatsappStats.connectedSince}</p>
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">Business Profile</label>
                          <p className="text-gray-900">Company CRM (Verified)</p>
                        </div>
                      </div>
                    </div>

                    <div>
                      <h3 className="text-lg font-medium text-gray-800 mb-3">Usage Statistics</h3>
                      <div className="bg-gray-50 rounded-lg p-4">
                        <div className="flex justify-between mb-3">
                          <span className="text-gray-700">Message quota</span>
                          <span className="font-medium">1,000/1,000 messages</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2.5">
                          <div className="bg-green-600 h-2.5 rounded-full" style={{width: '85%'}}></div>
                        </div>
                        <div className="flex justify-between mt-4">
                          <span className="text-gray-700">Template messages</span>
                          <span className="font-medium">24/100 sent</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2.5 mt-1">
                          <div className="bg-blue-600 h-2.5 rounded-full" style={{width: '24%'}}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === 'email' && (
                <div>
                  <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-bold text-gray-800">Email Integration</h2>
                    <div className="flex items-center">
                      <span className={`px-3 py-1 rounded-full text-sm font-medium mr-3 ${emailConnected ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
                        {emailConnected ? 'Connected' : 'Disconnected'}
                      </span>
                      <button 
                        onClick={() => emailConnected ? setEmailConnected(false) : setShowEmailModal(true)}
                        className={`px-4 py-2 rounded-lg font-medium ${emailConnected ? 'bg-red-500 hover:bg-red-600' : 'bg-blue-500 hover:bg-blue-600'} text-white`}
                      >
                        {emailConnected ? 'Disconnect' : 'Connect'}
                      </button>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div>
                      <h3 className="text-lg font-medium text-gray-800 mb-3">Account Details</h3>
                      <div className="space-y-4">
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
                          <p className="text-gray-900">{emailAddress}</p>
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">Connected Since</label>
                          <p className="text-gray-900">{emailStats.connectedSince}</p>
                        </div>
                        <div>
                          <label className="block text-sm font-medium text-gray-700 mb-1">Server Status</label>
                          <p className="text-green-600 flex items-center">
                            <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
                            Operational
                          </p>
                        </div>
                      </div>
                    </div>

                    <div>
                      <h3 className="text-lg font-medium text-gray-800 mb-3">Email Metrics</h3>
                      <div className="bg-gray-50 rounded-lg p-4">
                        <div className="flex justify-between mb-3">
                          <span className="text-gray-700">Inbox capacity</span>
                          <span className="font-medium">12.4GB/15GB</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2.5">
                          <div className="bg-blue-600 h-2.5 rounded-full" style={{width: '82%'}}></div>
                        </div>
                        <div className="flex justify-between mt-4">
                          <span className="text-gray-700">Delivery rate</span>
                          <span className="font-medium">98.7%</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-2.5 mt-1">
                          <div className="bg-green-600 h-2.5 rounded-full" style={{width: '98.7%'}}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeTab === 'messages' && (
                <div>
                  <h2 className="text-xl font-bold text-gray-800 mb-6">Recent Communications</h2>
                  <div className="border border-gray-200 rounded-lg overflow-hidden">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Type
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Contact
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Preview
                          </th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Time
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {messages.map((message) => (
                          <tr key={message.id} className={message.unread ? 'bg-blue-50' : ''}>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${message.type === 'whatsapp' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`}>
                                {message.type}
                              </span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <div className="flex items-center">
                                <div className="h-8 w-8 rounded-full bg-gray-300 flex items-center justify-center mr-2">
                                  {message.contact.charAt(0)}
                                </div>
                                <div className="text-sm font-medium text-gray-900">{message.contact}</div>
                              </div>
                            </td>
                            <td className="px-6 py-4">
                              <div className="text-sm text-gray-900">{message.preview}</div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {message.time}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* WhatsApp Configuration Modal */}
        {showWhatsappModal && (
          <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Connect WhatsApp</h3>
              <div className="mb-4">
                <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="whatsapp-number">
                  WhatsApp Business Number
                </label>
                <input
                  type="text"
                  id="whatsapp-number"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                  placeholder="+1 234 567 8900"
                  value={whatsappNumber}
                  onChange={(e) => setWhatsappNumber(e.target.value)}
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="business-id">
                  Business ID
                </label>
                <input
                  type="text"
                  id="business-id"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                  placeholder="Enter your business ID"
                />
              </div>
              <div className="mb-6">
                <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="access-token">
                  Access Token
                </label>
                <input
                  type="password"
                  id="access-token"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
                  placeholder="Enter your access token"
                />
              </div>
              <div className="flex justify-end space-x-3">
                <button
                  onClick={() => setShowWhatsappModal(false)}
                  className="px-4 py-2 text-gray-700 rounded-lg hover:bg-gray-100"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    if (whatsappNumber) {
                      setWhatsappConnected(true);
                      setShowWhatsappModal(false);
                    }
                  }}
                  className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600"
                >
                  Connect
                </button>
              </div>
            </div>
          </div>
        )}
        
        {/* Email Configuration Modal */}
        {showEmailModal && (
          <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6">
              <h3 className="text-xl font-semibold text-gray-800 mb-4">Connect Email</h3>
              <div className="mb-4">
                <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="email-address">
                  Email Address
                </label>
                <input
                  type="email"
                  id="email-address"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="your.email@example.com"
                  value={emailAddress}
                  onChange={(e) => setEmailAddress(e.target.value)}
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="email-password">
                  key
                </label>
                <input
                  type="password"
                  id="email-password"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Your key"
                />
              </div>
              <div className="mb-6">
                <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="smtp-server">
                  SMTP Server
                </label>
                <input
                  type="text"
                  id="smtp-server"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="smtp.example.com"
                />
              </div>
              <div className="flex justify-end space-x-3">
                <button
                  onClick={() => setShowEmailModal(false)}
                  className="px-4 py-2 text-gray-700 rounded-lg hover:bg-gray-100"
                >
                  Cancel
                </button>
                <button
                  onClick={() => {
                    if (emailAddress) {
                      setEmailConnected(true);
                      setShowEmailModal(false);
                    }
                  }}
                  className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
                >
                  Connect
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}